'use client';
import dynamic from 'next/dynamic';
import {
  Container,
  PageSection,
  PageSectionTitle,
} from '@/src/packages/components';
import { RangeMasthead } from './RangeMasthead';
import { RangeContext } from './RangeContext';
const RangeMaterials = dynamic(() =>
  import('./RangeMaterials').then((mod) => mod.RangeMaterials)
);
const RangeReviews = dynamic(() =>
  import('./RangeReviews').then((mod) => mod.RangeReviews)
);
const RangeProducts = dynamic(() =>
  import('./RangeProducts').then((mod) => mod.RangeProducts)
);
const RangeGallery = dynamic(() =>
  import('@/src/packages/components/pages/Range/RangeGallery').then(
    (mod) => mod.RangeGallery
  )
);
import { RangeManufacturingProcesses } from '@/src/packages/components/pages/Range/RangeManufacturingProcesses';
import {
  IArticle,
  IGallery,
  IManufacturingValue,
  IMaterial,
  IProductRange,
  IReview,
} from '@/src/interfaces/generated/contentful';
import {
  IFetchBundlesSchema,
  IFetchProductVariantGridSchema,
} from '@bitmap/contracts';
import { PageWrapper } from '@/src/packages/components/templates/PageWrapper';

import { PageSectionStack } from '@/src/packages/components/templates/PageSectionStack';
import { RangeBundles } from '@/src/packages/components/pages/Range/RangeBundles';

type IRangeProps = {
  range: IProductRange;
  gallery: IGallery | null;
  ranges: IProductRange[];
  articles: IArticle[];
  materials: IMaterial[];
  variants: IFetchProductVariantGridSchema[];
  manufacuringValues: IManufacturingValue[];
  reviews: IReview[];
  bundles: IFetchBundlesSchema;
};

export const Range = (props: IRangeProps) => {
  const { range, variants, ranges, reviews, gallery, bundles } = props;

  return (
    <RangeContext
      value={{
        range,
        ranges,
        gallery,
        bundles,
      }}
    >
      <PageWrapper paddingTop={0}>
        <Container>
          <PageSectionStack>
            <RangeMasthead />
            <PageSection>
              <PageSectionTitle>Shop bundles & save</PageSectionTitle>
              <RangeBundles bundles={bundles} />
            </PageSection>
            <RangeProducts variants={variants} />
            <RangeGallery />
            <RangeManufacturingProcesses />
            {range.fields.materials && range.fields.materials.length > 0 && (
              <RangeMaterials materials={range.fields.materials || []} />
            )}
            <RangeReviews reviews={reviews} />
          </PageSectionStack>
        </Container>
      </PageWrapper>
    </RangeContext>
  );
};
